import { Injectable, inject } from '@angular/core';
import { ApiService, PostCategory } from '@franbase/shared/data-access';
import { ComponentStore } from '@ngrx/component-store';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { EMPTY, catchError, map, switchMap, tap } from 'rxjs';


interface SharedPostCategoryStoreState extends EntityState<PostCategory> {
  loading: boolean,
  error: string,
}
const adapter = createEntityAdapter<PostCategory>();
const initialState: SharedPostCategoryStoreState = adapter.getInitialState({
  loading: false,
  error: '',
})

@Injectable({
  providedIn: 'root'
})
export class SharedPostCategoryStoreService extends ComponentStore<SharedPostCategoryStoreState> {

  apiSV = inject(ApiService);

  constructor() { super(initialState); }

  data$ = this.select((s) => Object.values(s.entities) as PostCategory[]);
  loading$ = this.select((s) => s.loading);
  error$ = this.select((s) => s.error);

  loadPostCategory$ = this.effect(none$ => {
    return none$.pipe(
      tap(() => {
        this.patchState({ loading: true, error: '' });
      }),
      switchMap(() => {
        return this.apiSV.listPostCategory();
      }),
      map(categories => {
        console.log(categories);
        if (categories.data && categories.data.length > 0)
          this.setState((state) => adapter.setAll(categories.data, state));
        this.patchState({ loading: false, error: '' });
      }),
      catchError(err => {
        this.patchState({ loading: false, error: err as string });
        return EMPTY;
      })
    )
  });

  getOnePostCategory(post_category_id: string) {
    return this.select((s) => s.entities[post_category_id] as PostCategory).pipe(
      tap(post_category => {
        if (!post_category) {
          this.apiSV.postCategoryDetail('id', post_category_id).then(rs => {
            this.setState((state) => adapter.setOne(rs.data, state));
          })
        }
      })
    );
  }
}
